<template>
  <b-container fluid>
    <h2 class="mt-4">Overview</h2>
    <b-form-group label="Filters">
      <b-form-radio-group
        id="list-filters"
        v-model="selectedFilter"
        :options="filters"
        name="filters"
      ></b-form-radio-group>
    </b-form-group>
    <b-form-input v-model="searchTeam" placeholder="Search Team"></b-form-input>
    <b-table
      :fields="fields"
      :items="athletes"
      head-variant="dark"
      small
      sort-by="team"
      sort-icon-left
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(checkedIn)="data">
        <span v-if="data.item.checkedIn">Yes</span>
        <span v-else>No</span>
      </template>
      <template v-slot:cell(equipment)="data">
        <span v-if="data.item.gloves && data.item.shinguards">Done</span>
      </template>
      <template v-slot:cell(competition_fit)="data">
        <span v-if="data.item.competition_fit === true">Yes</span>
        <span v-if="data.item.competition_fit === false" class="text-danger font-weight-bold">
          No
        </span>
        <span v-if="data.item.competition_fit === null">Waiting</span>
      </template>
      <template v-slot:cell(weight)="data">
        <span v-if="hasCorrectWeight(data.item)===true">{{ data.item.weight + ' kg' }}</span>
        <span v-if="hasCorrectWeight(data.item)===false" class="text-danger font-weight-bold">
          {{ data.item.weight + ' kg' }}
        </span>
      </template>
      <template v-slot:cell(weightClass)="data">
        <span class="text-capitalize">{{ data.item.weight_class.name }}</span>
      </template>
      <template v-slot:cell(action)="data">
        <b-button
          block
          size="sm"
          variant="primary"
          @click="edit(data.item)"
        >Edit</b-button>
      </template>
    </b-table>
    <b-modal size="xl" title="Edit Athlete" v-model="showModal">
      <p>
        {{ selectedAthlete.first_name }} {{ selectedAthlete.last_name }}<br>
        {{ selectedAthlete.team }}
      </p>
      <p>
        <b-badge v-if="selectedAthlete.checkedIn" variant="success">Checked in</b-badge>
        <b-badge v-else>Has not checked in yet.</b-badge>
        <br>
        <b-badge v-if="selectedAthlete.competition_fit" variant="success"
        >Competition fit</b-badge>
        <b-badge v-if="selectedAthlete.competition_fit === false" variant="danger"
        >Not competition fit</b-badge>
        <b-badge v-if="selectedAthlete.competition_fit === null"
        >No medical evaluation yet</b-badge>
        <br>
        <b-badge v-if="hasCorrectWeight(selectedAthlete)" variant="success">On weight</b-badge>
        <b-badge v-if="hasCorrectWeight(selectedAthlete) === false" variant="danger"
        >Not on weight</b-badge>
        <b-badge v-if="hasCorrectWeight(selectedAthlete) === null">Not on scale yet</b-badge>
      </p>
      <form>
        <b-row>
          <b-col>
            <div class="form-group">
              <label for="weightClassSelect">Weight class</label>
              <b-form-select
                id="weightClassSelect"
                :options="weightClassOptions"
                v-model="selectedAthlete.weight_class.name"
              ></b-form-select>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label for="weightMaxInput">Weight max</label>
              <input
                class="form-control"
                :disabled="selectedAthlete.weight_class.name !== 'catchweight'"
                id="weightMaxInput"
                max="200.0"
                min="40.0"
                step="0.1"
                v-model="selectedAthlete.weight_class.weight_max"
                type="number"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label for="weight">Weight</label>
              <input
                class="form-control"
                disabled
                id="weight"
                v-model="selectedAthlete.weight"
              >
            </div>
          </b-col>
        </b-row>
      </form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal=false">Cancel</b-button>
        <b-button variant="primary" @click="saveAthlete(selectedAthlete)">Save</b-button>
      </template>
    </b-modal>
    <b-table
        :fields="summaryFields"
        :items="summaryItems"
        head-variant="dark"
    ></b-table>
  </b-container>
</template>

<script>
export default {
  name: 'Overview',
  data() {
    return {
      summaryFields: ['weightClass', 'number'],
      fields: [
        { key: 'team', sortable: true },
        { key: 'first_name', sortable: true },
        { key: 'last_name', sortable: true },
        { key: 'checkedIn', sortable: true },
        { key: 'competition_fit', sortable: true },
        'weight', 'weightClass', 'action',
      ],
      filters: [
        { text: 'All', value: null },
        { text: 'Ready', value: true },
        { text: 'Rejected', value: false },
      ],
      searchTeam: '',
      selectedAthlete: {
        weight_class: {
          weight: null,
        },
      },
      selectedFilter: null,
      showModal: false,
      summaryItems: [
        { weightClass: 'Lightweight', number: 7 },
        { weightClass: 'Welterweight', number: 1 },
        { weightClass: 'Middleweight', number: 3 },
      ],
      weightClassOptions: [
        { value: 'lightweight', text: 'Lightweight' },
        { value: 'welterweight', text: 'Welterweight' },
        { value: 'middleweight', text: 'Middleweight' },
        { value: 'light-heavyweight', text: 'Light-Heavyweight' },
        { value: 'heavyweight', text: 'Heavyweight' },
        { value: 'catchweight', text: 'Catchweight' },
      ],
    };
  },
  methods: {
    edit(athlete) {
      this.selectedAthlete = athlete;
      this.showModal = true;
    },
    hasCorrectWeight(athlete) {
      if (!athlete.weight) return null;
      return this.$store.getters.hasCorrectWeight(athlete.id);
    },
    rowClass(item) {
      if (item.competition_fit === false) return 'table-danger';
      if (this.$store.getters.hasCorrectWeight(item.id) === false) return 'table-danger';
      if (item.checkedIn
        && item.competition_fit === true
        && item.weight) {
        return 'table-success';
      }
      return '';
    },
    saveAthlete(athlete) {
      console.log(athlete);
      this.showModal = false;
    },
  },
  computed: {
    athletes() {
      let athletes = this.$store.getters.getAthletes;
      if (this.searchTeam) {
        athletes = athletes.filter((a) => a.team.toLowerCase()
          .includes(this.searchTeam.toLowerCase()));
      }
      if (this.selectedFilter === true) {
        return athletes.filter((a) => a.competition_fit && this.hasCorrectWeight(a));
      }
      if (this.selectedFilter === false) {
        return athletes.filter((a) => a.competition_fit === false
          || this.hasCorrectWeight(a) === false);
      }
      return athletes;
    },
  },
};
</script>
